import React from "react";
import { useTranslation } from "react-i18next";

interface VCModalProps {
  data: any;
  onClose: () => void;
}

const VCModal: React.FC<VCModalProps> = ({ data, onClose }) => {
  const { t } = useTranslation();
  const jsonData = JSON.stringify(data, null, 2);

  return (
    <div className="bg-gray-600 bg-opacity-50 overflow-y-auto  w-full flex justify-center items-center">
      <div className="modalContent bg-white p-5 rounded-lg shadow-lg w-full  overflow-auto flex flex-col justify-between">
        <h2 className="text-lg font-bold mb-4">{t("verification.vc_data")}</h2>
        <pre className="whitespace-pre-wrap text-sm overflow-y-auto h-96 w-full">
          {jsonData}
        </pre>
        <button
          onClick={onClose}
          className="mt-4 px-4 pt-2 font-bold btn-secondary self-center"
        >
          {t("verification.close")}
        </button>
      </div>
    </div>
  );
};

export default VCModal;
